import isObject from 'lodash/isObject'
import { jsonStringify, jsonTryParse } from '../json'
import { getWindow } from '../get-window'

export interface IStorage<T> {
  get: (key: string, shouldParseAsObject?: boolean) => T | string
  set: (key: string, value: T) => void
  remove: (key: string) => void
  clear: () => void
  getStorage: () => any
}

const win = getWindow()

class BaseStorage<T = any> implements IStorage<T> {
  constructor(protected storage?: Storage) {
    //the default storage
    if (!storage) {
      this.storage = win.localStorage
    }
  }

  get = (key: string, shouldParseAsObject = false) => {
    //if this is called on SSR without the storage, we will just ignore it
    if (!this.storage) return null

    let result: string | T = this.storage.getItem(key)

    if (shouldParseAsObject) {
      result = jsonTryParse(result) //JSON.parse(storedResult)
    }
    return result
  }
  set = (key: string, value: T | string) => {
    //if this is called on SSR without the storage, we will just ignore it
    if (!this.storage) return

    let storedValue = value as unknown as string
    if (isObject(value)) storedValue = jsonStringify(value)
    this.storage?.setItem?.(key, storedValue)
  }
  remove = (key: string) => {
    //if this is called on SSR without the storage, we will just ignore it
    if (!this.storage) return

    this.storage?.removeItem(key)
  }
  clear = () => {
    //if this is called on SSR without the storage, we will just ignore it
    if (!this.storage) return

    this.storage?.clear()
  }
  getStorage = () => {
    //if this is called on SSR without the storage, we will just ignore it
    if (!this.storage) return null

    return this?.storage
  }
}

export class SessionStorage<T = any> extends BaseStorage<T> {
  constructor() {
    super(win.sessionStorage)
  }
}

export class LocalStorage<T = any> extends BaseStorage<T> {
  constructor() {
    super(win.localStorage)
  }
}
